module.exports = __webpack_public_path__ + "img/1_2-finanziario-attico-2.3fd5e85c.png";